export const LOAD_BATTERY_PAGE = 'battery/LOAD_BATTERY_PAGE'

export const GET_BATTERY_STATUS_REQUEST = 'battery/GET_BATTERY_STATUS_REQUEST'
export const GET_BATTERY_STATUS_SUCCESS = 'battery/GET_BATTERY_STATUS_SUCCESS'
export const GET_BATTERY_STATUS_FAILURE = 'battery/GET_BATTERY_STATUS_FAILURE'

export const SET_BATTERY_DEVICE_ID = 'battery/SET_BATTERY_DEVICE_ID'

export const ACTIVITY = {
  CHARGING: 'CHARGING',
  DISCHARGING: 'DISCHARGING',
  SUPPORTING_GRID: 'SUPPORTING_GRID',
  BACKUP: 'BACKUP',
  IDLE: 'IDLE',
}

export const IDLE_POWER_THRESHOLD_W = 50
